import { Command, ReplyUnion, TypeMapping } from '@redis/client/dist/lib/RESP/types';
import SEARCH, { SearchRawReply } from './SEARCH';

export default {
  parseCommand(...args: Parameters<typeof SEARCH.parseCommand>) {
    SEARCH.parseCommand(...args);
    args[0].push('NOCONTENT');
  },
  transformReply: {
    2: (reply: SearchRawReply): SearchNoContentReply => {
      return {
        total: reply[0] as number,
        documents: reply.slice(1) as Array<string>,
        // FT.SEARCH only emits warnings on RESP3; RESP2 replies never carry them.
        warnings: []
      }
    },
    3: (
      reply: ReplyUnion,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- matches TransformReply contract
      preserve?: any,
      typeMapping?: TypeMapping
    ): SearchNoContentReply => {
      const transformed = SEARCH.transformReply[3](reply, preserve, typeMapping) as {
        total: number;
        documents: Array<{
          id: string;
        }>;
        warnings: Array<string>;
      };

      return {
        total: transformed.total,
        documents: transformed.documents.map(document => document.id),
        warnings: transformed.warnings
      };
    }
  },
} as const satisfies Command;

export interface SearchNoContentReply {
  total: number;
  documents: Array<string>;
  /**
   * Warnings returned alongside partial results (e.g. on query timeout under a
   * `return` / `return-strict` on-timeout policy). Only populated on RESP3;
   * always empty on RESP2.
   */
  warnings: Array<string>;
};
